import { useEffect } from 'react';

export const useNormalizeGamePath = () => {
  useEffect(() => {
    const basePath = import.meta.env?.VITE_BASE_PATH || '/';
    const gameScreens = ['phonics', 'math', 'reading', 'science', 'art', 'geography', 'history', 'spelling'];
    const segments = (window.location.pathname || '').split('/').filter(Boolean);
    const lastSeg = segments[segments.length - 1];
    if (gameScreens.includes(lastSeg) && !window.location.hash.includes(`/${lastSeg}`)) {
      const pathPrefix = basePath === '/' ? '' : basePath.replace(/\/$/, '');
      const target = `${window.location.origin}${pathPrefix}/#/${lastSeg}`;
      if (window.location.href !== target) {
        window.location.replace(target);
      }
    }
  }, []);
};

export default useNormalizeGamePath;
